<template>
  <section class="form__content">
    <h3>4. {{ $t('accommodation.title') }}</h3>
    <v-switch :label="$t('accommodation.crous')"
              :value="choiceCrous"
              @change="$emit('update:choiceCrous', $event)"
    />

    <slot v-if="choiceCrous"/>

    <div v-html="$t('accommodation.crousInformations')" v-if="choiceCrous"/>

    <v-switch :label="$t('accommodation.isMui')"
              :value="mui"
              @change="$emit('update:mui', $event)"
    >
      <template v-slot:append>
        <a href="http://www.amitel.eu/nos-residences/residence-maison-universitaire-internationale/#rates"
           target="_blank" data-bcup-haslogintext="no">{{ $t('accommodation.mui.append') }}</a>
      </template>
    </v-switch>

    <v-select v-if="mui"
              :value="muiChoice1"
              @input="$emit('update:muiChoice1', $event)"
              :items="select1Items"
    />
    <v-select v-if="mui"
              :value="muiChoice2"
              @input="$emit('update:muiChoice2', $event)"
              :items="select2Items"
    />
    <v-select v-if="mui"
              :value="muiChoice3"
              @input="$emit('update:muiChoice3', $event)"
              :items="select3Items"
    />
  </section>
</template>

<script>
export default {
  name: 'SepAccomodation',

  props: {
    mui: {
      required: true,
      type: Boolean,
    },
    muiChoice1: {
      required: true,
    },
    muiChoice2: {
      required: true,
    },
    muiChoice3: {
      required: true,
    },
    choiceCrous: {
      required: true,
    }
  },

  computed: {
    select1Items () {
      return this.selectValues.filter(value => {
        return value.value !== this.muiChoice2 && value.value !== this.muiChoice3
      })
    },
    select2Items () {
      return this.selectValues.filter(value => {
        return value.value !== this.muiChoice1 && value.value !== this.muiChoice3
      })
    },
    select3Items () {
      return this.selectValues.filter(value => {
        return value.value !== this.muiChoice1 && value.value !== this.muiChoice2
      })
    },
  },

  data () {
    return {
      selectValues: [
        { value: '-', text: this.$t('accommodation.mui.selectValues.-') },
        { value: 'classicPLS', text: this.$t('accommodation.mui.selectValues.classicPLS') },
        { value: 'classicSup', text: this.$t('accommodation.mui.selectValues.classicSup') },
        { value: 'clubPLS', text: this.$t('accommodation.mui.selectValues.clubPLS') },
        { value: 'spacePLS', text: this.$t('accommodation.mui.selectValues.spacePLS') },
        { value: 'spacePLSSup', text: this.$t('accommodation.mui.selectValues.spacePLSSup') },
        { value: 'furnishedStudio', text: this.$t('accommodation.mui.selectValues.furnishedStudio') },
        { value: 'shortTermStudio', text: this.$t('accommodation.mui.selectValues.shortTermStudio') },
      ],
    }
  },
}
</script>
